import React from "react";

export default function Video({ videoSrc }) {
  return (
    <>
      <div className="video-container">
        <video controls>
          <source src={videoSrc} type="video/mp4" />
        </video>
      </div>
    </>
  );
}
